// extracted by mini-css-extract-plugin
export default {"componentWrapper":"LoginButton_componentWrapper__-qVid","authButton":"LoginButton_authButton__LKE76"};